/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Doc_Vehicle_ProofInputs */

const en_case_doc_vehicle_proof = /** @type {(inputs: Case_Doc_Vehicle_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vehicle income/billing proof`)
};

const pt_br2_case_doc_vehicle_proof = /** @type {(inputs: Case_Doc_Vehicle_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprovante de rendimentos/faturamento veículo`)
};

/**
* | output |
* | --- |
* | "Vehicle income/billing proof" |
*
* @param {Case_Doc_Vehicle_ProofInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_doc_vehicle_proof = /** @type {((inputs?: Case_Doc_Vehicle_ProofInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Doc_Vehicle_ProofInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_doc_vehicle_proof(inputs)
	return pt_br2_case_doc_vehicle_proof(inputs)
});